"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dg_back_to_up_1 = __importDefault(require("./dg-back-to-up"));
var dg_back_to_top_1 = __importDefault(require("./dg-back-to-top"));
var dg_breadcrumb_1 = __importDefault(require("./dg-breadcrumb"));
var dg_card_1 = __importDefault(require("./dg-card"));
var dg_cardline_1 = __importDefault(require("./dg-cardline"));
var dg_cardtxt_1 = __importDefault(require("./dg-cardtxt"));
var dg_contextmenu_1 = __importDefault(require("./dg-contextmenu"));
var dg_databasket_1 = __importDefault(require("./dg-databasket"));
var dg_dialog_1 = __importDefault(require("./dg-dialog"));
var dg_dict_tree_1 = __importDefault(require("./dg-dict-tree"));
var dg_drawer_1 = __importDefault(require("./dg-drawer"));
var dg_dropdown_multiple_1 = __importDefault(require("./dg-dropdown-multiple"));
var dg_form_1 = __importDefault(require("./dg-form"));
var dg_iframe_1 = __importDefault(require("./dg-iframe"));
var dg_json_view_1 = __importDefault(require("./dg-json-view"));
var dg_kanban_1 = __importDefault(require("./dg-kanban"));
var dg_knowledge_base_select_1 = __importDefault(require("./dg-knowledge-base-select"));
var dg_menu_1 = __importDefault(require("./dg-menu"));
var dg_message_1 = __importDefault(require("./dg-message"));
var dg_mode_1 = __importDefault(require("./dg-mode"));
var dg_notice_1 = __importDefault(require("./dg-notice"));
var dg_page_header_1 = __importDefault(require("./dg-page-header"));
var dg_search_1 = __importDefault(require("./dg-search"));
var dg_select_1 = __importDefault(require("./dg-select"));
var dg_sidebar_frame_1 = __importDefault(require("./dg-sidebar-frame"));
var dg_svg_icon_1 = __importDefault(require("./dg-svg-icon"));
var dg_tab_select_1 = __importDefault(require("./dg-tab-select"));
var dg_table_v1_1 = __importDefault(require("./dg-table-v1"));
var dg_table_1 = __importDefault(require("./dg-table"));
var dg_tooltip_1 = __importDefault(require("./dg-tooltip"));
var dg_topic_tree_mgr_1 = __importDefault(require("./dg-topic-tree-mgr"));
var dg_transfer_1 = __importDefault(require("./dg-transfer"));
var dg_tree_1 = __importDefault(require("./dg-tree"));
var dg_tree_select_1 = __importDefault(require("./dg-tree-select"));
var dg_tree_with_menu_1 = __importDefault(require("./dg-tree-with-menu"));
var dg_validate_password_form_1 = __importDefault(require("./dg-validate-password-form"));
var dg_vxe_table_1 = __importDefault(require("./dg-vxe-table"));
var dg_editor_1 = __importDefault(require("./dg-editor"));
var dg_codemirror_1 = __importDefault(require("./dg-codemirror"));
var dg_edit_form_1 = __importDefault(require("./dg-edit-form"));
var dg_dict_1 = __importDefault(require("./dg-dict"));
var dg_api_select_1 = __importDefault(require("./dg-api-select"));
var dg_dim_select_1 = __importDefault(require("./dg-dim-select"));
exports.default = [
    dg_back_to_up_1.default,
    dg_back_to_top_1.default,
    dg_breadcrumb_1.default,
    dg_codemirror_1.default,
    dg_card_1.default,
    dg_cardline_1.default,
    dg_cardtxt_1.default,
    dg_contextmenu_1.default,
    dg_databasket_1.default,
    dg_dialog_1.default,
    dg_dict_tree_1.default,
    dg_dict_1.default,
    dg_drawer_1.default,
    dg_dropdown_multiple_1.default,
    dg_editor_1.default,
    dg_form_1.default,
    dg_iframe_1.default,
    dg_json_view_1.default,
    dg_kanban_1.default,
    dg_knowledge_base_select_1.default,
    dg_menu_1.default,
    dg_message_1.default,
    dg_mode_1.default,
    dg_notice_1.default,
    dg_page_header_1.default,
    dg_search_1.default,
    dg_select_1.default,
    dg_svg_icon_1.default,
    dg_sidebar_frame_1.default,
    dg_tab_select_1.default,
    dg_table_v1_1.default,
    dg_table_1.default,
    dg_tooltip_1.default,
    dg_topic_tree_mgr_1.default,
    dg_transfer_1.default,
    dg_tree_1.default,
    dg_tree_select_1.default,
    dg_tree_with_menu_1.default,
    dg_tree_1.default,
    dg_validate_password_form_1.default,
    dg_vxe_table_1.default,
    dg_edit_form_1.default,
    dg_api_select_1.default,
    dg_dim_select_1.default
];
